import React, { useEffect, useMemo, useState } from "react";
import AddProjectSelect from "./AddProjectSelect";
import SelectBtn from "./SelectBtn";
import SelectBtnProject from "./SelectBtnProject"; //Добавлено
import { Item } from "../../types";

type Props = {
  list: Item[];
  selected: Item | null;
  selectHandler: (value: string | number, target: any) => void;
  disabled?: boolean;
  className?: string;
  headOptions?: object;
  placeholder?: string;
  fieldName?: string;
  setPage?: (page: number) => void;
  page?: number;
  searchData?: (value: string) => void;
  projectsSelect?: any; // Добавлен тип для нового props
};

const SelectWithSecondaryBtn: React.FC<Props> = ({
  headOptions,
  fieldName,
  list,
  selected,
  selectHandler,
  className,
  disabled = false,
  setPage,
  page,
  searchData,
  placeholder,
  projectsSelect, // Добавлен новый props
}) => {
  let filteredValues: Item[] = [];
  const [searchString, setSearchString] = useState<string>("");

  if (!searchData) {
    if (searchString !== "") {
      list.forEach((listItem) => {
        if (listItem.text.toLowerCase().includes(searchString.toLowerCase())) {
          filteredValues.push(listItem);
        }
      });
    }
  }
  useEffect(() => {
    if (searchData) searchData(searchString);
  }, [searchString]);

  useMemo(() => {
    setSearchString("");
  }, [selected]);

  return (
    <AddProjectSelect
      fieldName={fieldName}
      setPage={setPage}
      page={page}
      headOptions={headOptions}
      itemsList={searchString === "" || searchData ? list : filteredValues}
      selectedItem={selected}
      selectHandler={selectHandler}
      className={className ? className : "" + fieldName}
      disabled={disabled}
      closeWindow={(obj) => setSearchString(obj)}
      projectsSelect={projectsSelect}
    >
      <SelectBtnProject // Добавлен новый компонент для проектов
        projectsSelect={projectsSelect} // Добавлен новый props
        searchString={searchString}
        placeholder={placeholder}
        setSearchString={(obj) => {
          setSearchString(obj);
        }}
      />
    </AddProjectSelect>
  );
};

export default SelectWithSecondaryBtn;
